import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { UserRole, User } from '@/misc/types'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User>(new User())

  const clearUser = () => {
    user.value = new User()
  }

  const setUser = (u: any) => {
    user.value = new User(
      u.oid,
      u.name,
      +u.role,
      u.username,
      u.projects ?? user.value.projects,
      Boolean(u.can_manage_users),
      Array.isArray(u.user_account_managed_usernames) ? u.user_account_managed_usernames : [],
      Array.isArray(u.user_account_managed_project_ids)
        ? u.user_account_managed_project_ids.map((pid: any) => Number(pid))
        : [],
      Boolean(u.impersonated),
      u.impersonator_username ?? null,
      typeof u.impersonated_role === 'number' ? u.impersonated_role : null,
      Array.isArray(u.impersonated_project_ids)
        ? u.impersonated_project_ids.map((pid: any) => Number(pid))
        : null,
      (u.impersonation_mode as 'user' | 'access' | null) ?? null
    )
  }

  const isAuthenticated = computed(() => user.value.isAuthenticated())
  const isImpersonating = computed(() => user.value.isImpersonating())

  const hasAdminAccess = computed(() => user.value.isAdmin())
  const hasUserManagementAccess = computed(
    () => user.value.isAdmin() || Boolean(user.value.canManageUsers)
  )
  const hasWriteAccess = computed(() => user.value.isWriter() || user.value.isAdmin())
  const hasReadAccess = computed(
    () => user.value.isReader() || user.value.isWriter() || user.value.isAdmin()
  )

  return {
    user,
    clearUser,
    setUser,
    isAuthenticated,
    hasAdminAccess,
    hasUserManagementAccess,
    hasWriteAccess,
    hasReadAccess,
    isImpersonating
  }
})
